const exitPreviewMode = async () => {
  await fetch("/api/strapi/exit-preview");
  window.location.reload();
  return;
};

export const MyButton = ({ onClick, text }) => {
  return (
    <button
      onClick={onClick}
      className="bg-white hover:bg-gray-100 text-purple-600 px-4 rounded-lg"
    >
      {text}
    </button>
  );
};

const TurnOffPreviewButton = () => {
  return (
    <div className="w-full bg-purple-600 text-white font-semibold py-2 px-4 text-center">
      Currently in preview mode{" "}
      <MyButton onClick={() => exitPreviewMode()} text="Turn off preview" />
    </div>
  );
};

export default TurnOffPreviewButton;
